import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useParams } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/domestic.jpg';
import { ReactComponent as Truck } from '../../../assets/icons/truck-1.svg';
import { domesticImage } from '../../assets/asset-url';

interface Props extends PropsFromRedux {}

const TrackAlpha: React.FC<Props> = ({
  hideModal,
  showModal,
  modal,
  alphaLogin,
  alphaLoginState,
}) => {
  const closeModal = () => {
    hideModal();
  };
  const { trackingAlpha } = useParams<{ trackingAlpha: string }>();

  //   React.useEffect(() => {
  //     alphaLogin();
  //   }, [alphaLogin]);

  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return (
    <div className="w-full px-2 bg-white py-6 relative">
      <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>

      <div className="my-5 mx-2 py-4 flex ">
        <div className="text-lg py-10 px-6">
          <img
            src={domesticImage}
            alt="GIG App"
            className="lg:w-60 md:w-11/12  w-11/12 -mt-2"
          />
        </div>
        <div className="sm:w-2/3 w-full mx-8">
          <h4 className="text-base mt-4 lg:text-2xl md:text-2xl font-medium ">
            Oxford shoes
          </h4>
          <div className="w-full lg:flex md:flex my-2 mb-8">
            {/* <div className="inline-flex items-center justify-center mr-2 leading-none bg-white py-5 p-4 rounded-full"> */}
            <img
              className="lg:w-12 md:w-12 w-12 h-12 rounded-full mr-4"
              src={domesticImage}
              alt="store-img"
            />
            {/* </div> */}
            <div className="w-full mt-2">
              <h5 className="font-medium text-xs text-gray-400">Store name</h5>
              <p className="lg:text-sm md:text-sm text-xs text-gray-800 font-medium">
                Tee's Footwear
              </p>
            </div>
          </div>
          <p className="text-xs md:text-lg lg:text-lg py-2 lg:-mt-6 mb-3 -mt-10 text-green-600 font-semibold flex flex-grow  items-end md:text-sm">
            ₦ 45,000
          </p>

          <a className="w-full lg:w-36 text-center bg-gray-800 cursor-pointer text-xs font-medium rounded text-white p-2 lg:px-12 sm:py-2">
            View More
          </a>
        </div>
      </div>
    </div>
  );
  // </ModalWrapper>
};

export default TrackAlpha;
